module.exports = __webpack_public_path__ + "img/gas.f5fbc52d.png";